<div class="trademarks-container">
  <div class="trademarks-item-container">
    <div class="trademarks-item-input-container">
      <mat-form-field appearance="outline" class="trademarks-form-field">
        <mat-label>Trademark(s)</mat-label>
        <input matInput #trademarksInput [(ngModel)]="trademarks" class="trademarks trademarks-item-input"
          (keyup.enter)="updateTrademarks($event)" (keyup.escape)="cancelUpdate()" (blur)="updateTrademarks($event)" />
        <mat-icon matSuffix (mousedown)="clearTrademarksInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('trademarks')">
      This is a required field.
    </div>
  </div>
 <!--  <div *ngIf="formType ==='FormC'" class="trademarks-info trademarks-info-text">
    Include any trade names obtained since first USAN was adopted.
  </div> -->
  <div class="trademarks-info trademarks-info-text">
    Any trademark issued for the drug should be provided. Any known foreign trademarks along with the name of the country of registry should be included.
  </div>
</div>